import { createStore } from 'jotai';
import { useEffect, useMemo } from 'react';
import { makePreferenceClientEffects } from 'js/file_viewer/core/atoms/store/preferences';
export const useJotaiStore = (opts) => {
    const { optionalIOClients } = opts;
    const { preferencesClient } = optionalIOClients;
    const store = useMemo(() => createStore(), []);
    useEffect(() => {
        const cleanupPreferences = preferencesClient
            ? makePreferenceClientEffects(store, preferencesClient)
            : undefined;
        return () => {
            cleanupPreferences === null || cleanupPreferences === void 0 ? void 0 : cleanupPreferences();
        };
    }, [store, preferencesClient]);
    return store;
};
//# sourceMappingURL=use_store.preenvesnextjs.map
